import React, { FC } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { getCalendarTime } from '../../../utils/convertTime';
import { IEvent } from '../../../models/types';

import Typography from '../../Typography';

import DrawerContentItem from '../DrawerContentItem';

import NotificationIcon from '../../Notification/NotificationIcon';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    '& > *:not(:last-child)': {
      marginBottom: spacing(0.5)
    }
  },
  target: {
    '& > *:not(:last-child)': {
      marginRight: spacing(0.5)
    }
  }
}));

interface IProps {
  notification: IEvent;
}

const DrawerContentItemNotification: FC<IProps> = ({ notification }) => {
  const classes = useStyles();

  const { class: classId, classFriendly, platformText, eventTime } = notification;

  const icon = <NotificationIcon notificationClass={classId} size="m" />;

  const content = (
    <Grid className={classes.root}>
      <Typography variant="p2Bold">{classFriendly}</Typography>
      <Typography variant="p2Regular">
        <div dangerouslySetInnerHTML={{ __html: platformText }} />
      </Typography>
      <Grid container alignItems="center" className={classes.target}>
        {/*<NotificationTarget targetSimple={targetSimple} size="s" />*/}
        <Typography variant="p3Regular" color="text-secondary">
          {`${getCalendarTime(eventTime, 'DD.MM.YY')}, ${moment(eventTime).format('HH:mm')}`}
        </Typography>
      </Grid>
    </Grid>
  );

  return <DrawerContentItem icon={icon} content={content} align="stretch" />;
};

export default DrawerContentItemNotification;
